import {Box, clsx} from 'external/material'
import {Link} from 'external/react'
import {PreviewIcon, MessageIcon} from 'resources/icons'
import useSession from 'hooks/session'

export default function ActivityItemLink(props) {
    const {navigation} = useSession()
    const {group, type} = props
    const link = navigation.section.link({pageName: 'my-courses', groupId: group.id, section: type == 'quiz' ? 'assessment' : 'homework'})
    return (<Box className="links">
      <Link className="link" to={link}><PreviewIcon fill="#2c75bd" width={25} /></Link>
      {props.onMessageClick && <span onClick={props.onMessageClick} className={clsx("link", "message")}><MessageIcon fill="#2c75bd" width={18} /></span>}
      </Box>
    )
}
